export default function Chip(theme) {
    return {
        MuiChip: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.primary.main
                }
            }
        }
    };
}
